// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dabd1bbd","455":"4bbdf95e"}[chunkId] + ".chunk.js";
};